document.addEventListener('DOMContentLoaded', function () {
  const quickViewButtons = document.querySelectorAll('.show-product-quickview');

  quickViewButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      try {
        console.log('data-product', btn.getAttribute('data-product'));
        const productData = JSON.parse(btn.getAttribute('data-product'));
        quickViewCovertCurrency(productData);
      } catch (err) {
        console.error('Invalid product data', err);
      }
    });
  });
});